import { render, staticRenderFns } from "./CFeatures.vue?vue&type=template&id=7856b90e&"
import script from "./CFeatures.vue?vue&type=script&lang=js&"
export * from "./CFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports